import LoadingPanel from './loading-panel.component'

export default LoadingPanel
